import React, { Component } from 'react';
import classNames from 'classnames';

const DOCUMENT_EXTENSIONS = ['pdf', 'doc', 'docx'];
const DOCUMENT_MIME_TYPES = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
];

export const isValidDocumentFile = file => {
  const extension = file.name.split('.').pop()?.toLowerCase();
  return DOCUMENT_EXTENSIONS.includes(extension) || DOCUMENT_MIME_TYPES.includes(file.type);
};

class DragAndDrop extends Component {
  constructor(props) {
    super(props);
    this.dragCounter = 0; // Initialize drag counter to track drag state
  }
  state = {
    drag: false,
  };
  dropRef = React.createRef();
  // Handles drag events to prevent default browser behavior
  handleDrag = e => {
    e.preventDefault();
    e.stopPropagation();
  };
  // Handles dragenter event to detect when an item is dragged over the drop area
  handleDragIn = e => {
    e.preventDefault();
    e.stopPropagation();
    if (this.props.disabled) {
      return;
    }
    this.dragCounter++;
    if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
      this.setState({ drag: true });
    }
  };
  // Handles dragleave event to detect when the dragged item leaves the drop area
  handleDragOut = e => {
    e.preventDefault();
    e.stopPropagation();
    if (this.props.disabled) {
      return;
    }
    this.dragCounter--;
    if (this.dragCounter === 0) {
      this.setState({ drag: false });
    }
  };
  // Handles drop event to process the dropped files
  handleDrop = e => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ drag: false });
    if (this.props.disabled) {
      this.dragCounter = 0;
      return;
    }
    const files = e.dataTransfer.files;
    if (files && files.length > 0) {
      const filesArray = Array.from(files);

      if (this.props.acceptedFileType === 'document') {
        const validFiles = filesArray.filter(isValidDocumentFile);
        if (validFiles.length > 0) {
          this.props.handleDrop(validFiles);
        } else if (this.props.onInvalidFile) {
          this.props.onInvalidFile();
        } else {
          alert('Only PDF, DOC, and DOCX files are allowed.');
        }
        e.dataTransfer.clearData();
        this.dragCounter = 0;
        return;
      }

      if (this.props.acceptedFileType === 'media') {
        this.props.handleDrop(filesArray);
        e.dataTransfer.clearData();
        this.dragCounter = 0;
        return;
      }

      // Validate file types based on the acceptedFileType prop
      const validFiles = filesArray.filter(file => {
        // Check if file type matches the accepted type (video or image)
        if (this.props.acceptedFileType === 'video' && file.type.startsWith('video/')) {
          return true;
        }
        if (this.props.acceptedFileType === 'image' && file.type.startsWith('image/')) {
          return true;
        }
        return false; // Reject the file if type does not match
      });
      if (validFiles.length > 0) {
        this.props.handleDrop(validFiles); // Pass valid files to the parent
      } else if (this.props.onInvalidFile) {
        this.props.onInvalidFile();
      } else {
        // Handle invalid file type case (e.g., show an error or alert)
        alert(`Only ${this.props.acceptedFileType} files are allowed.`);
      }
      // Clear data and reset drag counter
      e.dataTransfer.clearData();
      this.dragCounter = 0;
    }
  };
  // Lifecycle methods to add/remove event listeners for drag and drop events
  componentDidMount() {
    const div = this.dropRef.current;
    div.addEventListener('dragenter', this.handleDragIn);
    div.addEventListener('dragleave', this.handleDragOut);
    div.addEventListener('dragover', this.handleDrag);
    div.addEventListener('drop', this.handleDrop);
  }
  componentWillUnmount() {
    const div = this.dropRef.current;
    div.removeEventListener('dragenter', this.handleDragIn);
    div.removeEventListener('dragleave', this.handleDragOut);
    div.removeEventListener('dragover', this.handleDrag);
    div.removeEventListener('drop', this.handleDrop);
  }
  render() {
    const dropZoneStyle = this.state.drag
      ? {
          outline: '2px dashed var(--marketplaceColor)',
          outlineOffset: '4px',
          backgroundColor: 'rgba(80, 31, 119, 0.08)',
        }
      : undefined;
    const classes = classNames(this.props.dragdrop, {
      [this.props.dragActiveClassName]: this.state.drag && this.props.dragActiveClassName,
    });

    return (
      <div className={classes} ref={this.dropRef} style={dropZoneStyle}>
        {this.props.children}
      </div>
    );
  }
}
export default DragAndDrop;
